export default __webpack_public_path__ + "static/media/processLoader.53d0a74a.gif";